export default __webpack_public_path__ + "static/media/intellync_logo.dd4653fd.png";